import { storeToRefs } from 'pinia';

import { generateDeviceFingerprintHandler } from '~/handlers/generate-device-fingerprint';
import { useDeviceStore } from '~/stores/apostatudo/device';

export const useDeviceFingerprint = () => {
  const deviceStore = useDeviceStore();
  const { fingerprint } = storeToRefs(deviceStore);

  const ensureFingerprint = async () => {
    if (fingerprint.value) {
      return fingerprint.value;
    }

    if (!import.meta.client) {
      return fingerprint.value;
    }

    const generatedFingerprint = await generateDeviceFingerprintHandler();

    if (generatedFingerprint) {
      deviceStore.setFingerprint(generatedFingerprint);

      return generatedFingerprint;
    }

    return fingerprint.value;
  };

  return {
    fingerprint,
    ensureFingerprint,
  };
};
